<app-main-navbar></app-main-navbar>

<!-- Page Title -->
<div class="page-title-area" [ngStyle]="{ 'background-image': 'url(' + pricingImage + ')' }">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <h1 class="text-start" i18n="@@ourPlansTitle">Our Plans</h1>
        <h2 class="text-start" i18n="@@ourPlansSubTitle">
          The easiest and cheapest way of connecting to your customers, no surprises, no hidden fees!
        </h2>
      </div>
    </div>
  </div>
  <div class="shape2 rotateme"><img src="assets/img/shapes/shape2.svg" alt="shape" /></div>
  <div class="shape3"><img src="assets/img/shapes/shape3.svg" alt="shape" /></div>
  <div class="shape4"><img src="assets/img/shapes/shape4.svg" alt="shape" /></div>
  <div class="shape5"><img src="assets/img/shapes/shape5.png" alt="shape" /></div>
  <div class="shape6 rotateme"><img src="assets/img/shapes/shape4.svg" alt="shape" /></div>
  <div class="shape7"><img src="assets/img/shapes/shape4.svg" alt="shape" /></div>
  <div class="shape8 rotateme"><img src="assets/img/shapes/shape2.svg" alt="shape" /></div>
</div>

<!-- Pricing -->
<div class="pricing-area ptb-80">
  <div class="container">
    <div class="section-title">
      <h3 i18n="@@ourPlansTitle">Our Plans</h3>
      <div class="bar"></div>
      <p i18n="@@ourPlansSubTitle">
        The easiest and cheapest way of connecting to your customers, no surprises, no hidden fees!
      </p>
    </div>
    <div class="pricing-tab bg-color">
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6 col-sm-6" *ngFor="let item of products; index as index">
          <app-plan-item [product]="item"></app-plan-item>
        </div>
      </div>
    </div>
  </div>
</div>
<app-wipperoz-numbers></app-wipperoz-numbers>
<div class="footer">
  <app-footer [showGoogle]="false"></app-footer>
</div>
